// What this page sent, by intent id, so an outcome on the stream can be told in words.

const LABELS = new Map<string, string>();

export function remember(intentId: string, label: string) {
  LABELS.set(intentId.toLowerCase(), label);
  if (LABELS.size > 200) {
    const first = LABELS.keys().next().value;
    if (first !== undefined) LABELS.delete(first);
  }
}

export function recall(intentId: string): string | undefined {
  return LABELS.get(intentId.toLowerCase());
}
